import {Modal, ModalProps} from 'antd';
import style from './index.module.scss';
import React from 'react';
import {pageTaskLog, TaskLogListItem} from '../../../../../service';
import OverLengthColumn from '../../../../../Components/OverLengthColumn';
import useTable from '../../../../../../../Utils/Hooks/useTable';
import TableRender, {ProColumnsType} from 'table-render';

interface LogDetailModalProps extends ModalProps {
    eid: string;
}

export default function LogDetailModal({
    eid,
    ...restProps
}: LogDetailModalProps) {
    const {tableInit} = useTable(pageTaskLog, {
        data: {eid},
    });

    const columns: ProColumnsType<TaskLogListItem> = [
        {
            title: '类型',
            dataIndex: 'type',
            align: 'left',
        },
        {
            title: '数据表',
            dataIndex: 'table',
            align: 'left',
        },
        {
            title: '数据',
            dataIndex: 'data',
            align: 'left',
            width: 400,
            render: (text: string) => (
                <OverLengthColumn
                    value={text}
                    width={350}
                    className={style.position}
                />
            ),
        },
        {
            title: '执行时间',
            dataIndex: 'time',
            align: 'left',
            width: 240,
        },
        {
            title: '执行结果',
            dataIndex: 'desc',
            align: 'left',
            render: (text: string) => (
                <OverLengthColumn
                    value={text}
                    width={150}
                    className={style.position}
                />
            ),
        },
    ];

    const schema = {
        type: 'object',
        labelWidth: 130,
        properties: {
            search: {
                title: '关键字',
                type: 'string',
            },
        },
    };

    return (
        <Modal
            title="查看日志"
            maskClosable={false}
            width={1200}
            className={style.root}
            footer={null}
            {...restProps}>
            <div className={style.box}>
                <TableRender
                    columns={columns}
                    rowKey="key"
                    search={{schema}}
                    {...tableInit()}
                />
            </div>
        </Modal>
    );
}
